var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState } from 'react';
import { getFileId } from '../lib/helpers';
export var useFileState = function (_a) {
    var uploadFormFile = _a.uploadFormFile;
    var _b = useState({}), files = _b[0], setFiles = _b[1];
    var _removeDuplicates = function (id, newFiles) {
        var duplicated = [];
        var toAdd = newFiles.filter(function (file) {
            var exists = (files[id] || {
                selectedFiles: [],
                overLimit: [],
                duplicated: [],
            }).selectedFiles.find(function (selectedFile) { return selectedFile.localId === getFileId(file); });
            if (exists) {
                duplicated.push(exists);
            }
            return !exists;
        });
        return [toAdd, duplicated];
    };
    var _cancelRequest = function (data) {
        if (data.cancelToken !== null) {
            try {
                data.cancelToken();
            }
            catch (error) {
                // swallow
            }
        }
    };
    var _getWithInLimit = function (files, limit) {
        var filesWithinLimit = [];
        for (var index = 0; index < files.length; index++) {
            if (index >= limit) {
                break;
            }
            var file = files[index];
            filesWithinLimit.push(file);
        }
        var filesOverLimit = files.slice(filesWithinLimit.length, files.length);
        return [filesWithinLimit, filesOverLimit];
    };
    var updateFileProgress = function (id, uniqLocalId, progress, uniqId, cancelToken) {
        if (uniqId === void 0) { uniqId = ''; }
        if (cancelToken === void 0) { cancelToken = null; }
        setFiles(function (files) {
            var _a;
            return (__assign(__assign({}, files), (_a = {}, _a[id] = __assign(__assign({}, files[id]), { selectedFiles: (files[id].selectedFiles || []).map(function (data) {
                    if (data.localId === uniqLocalId) {
                        return __assign(__assign({}, data), { id: uniqId, progress: progress, cancelToken: cancelToken });
                    }
                    return data;
                }) }), _a)));
        });
    };
    var addFiles = function (id, filesToAdd, limit) {
        var _a;
        if (limit === void 0) { limit = 1; }
        var _b = _getWithInLimit(filesToAdd, limit - (files[id] || { selectedFiles: [] }).selectedFiles.length), filesWithInLimit = _b[0], overLimit = _b[1];
        var _c = _removeDuplicates(id, filesWithInLimit), toAdd = _c[0], duplicated = _c[1];
        setFiles(__assign(__assign({}, files), (_a = {}, _a[id] = __assign(__assign({}, files[id]), { selectedFiles: __spreadArray(__spreadArray([], ((files[id] && files[id].selectedFiles) || []), true), toAdd.map(function (file) { return ({
                localId: getFileId(file),
                progress: 0,
                id: '',
                file: file,
                error: null,
                cancelToken: '',
            }); }), true), duplicated: duplicated, overLimit: overLimit }), _a)));
        return {
            added: toAdd,
            duplicated: duplicated,
            overLimit: overLimit,
        };
    };
    var setFileError = function (id, localFileId, error) {
        setFiles(function (files) {
            var _a;
            return (__assign(__assign({}, files), (_a = {}, _a[id] = __assign(__assign({}, files[id]), { selectedFiles: __spreadArray([], ((files[id] && files[id].selectedFiles) || []).map(function (selectedFile) {
                    if (selectedFile.localId === localFileId) {
                        return __assign(__assign({}, selectedFile), { error: error });
                    }
                    else {
                        return selectedFile;
                    }
                }), true) }), _a)));
        });
    };
    var addAndSendFiles = function (id, files, limit) {
        if (limit === void 0) { limit = 1; }
        var _a = addFiles(id, files, limit), added = _a.added, duplicated = _a.duplicated, overLimit = _a.overLimit;
        var uploadPromises = added.map(function (file) {
            var fileId = getFileId(file);
            var promise = uploadFormFile(id, fileId, file, updateFileProgress);
            promise.catch(function (error) {
                setFileError(id, fileId, error);
            });
            return promise;
        });
        return {
            added: added,
            duplicated: duplicated,
            overLimit: overLimit,
            uploadPromises: uploadPromises,
        };
    };
    var removeFile = function (id, position) {
        var _a;
        setFiles(__assign(__assign({}, files), (_a = {}, _a[id] = __assign(__assign({}, files[id]), { selectedFiles: files[id].selectedFiles.filter(function (data, _position) {
                if (_position !== position) {
                    return true;
                }
                _cancelRequest(data);
                return false;
            }) }), _a)));
    };
    var hasAtleastOneUploadedFile = function (id) {
        if (!(files[id] &&
            files[id].selectedFiles.length >= 1 &&
            files[id].selectedFiles.find(function (selectedFile) { return selectedFile.progress === 100; }))) {
            return false;
        }
        return true;
    };
    return {
        files: files,
        addAndSendFiles: addAndSendFiles,
        removeFile: removeFile,
        hasAtleastOneUploadedFile: hasAtleastOneUploadedFile,
    };
};
